import getEnv from 'utilities/getEnv'

export const DEPLOYMENT: 'selfhost' | 'cloud' =
    (getEnv('REACT_APP_DEPLOYMENT') as string)?.toLowerCase() === 'selfhost'
        ? 'selfhost'
        : 'cloud'

export const IS_SELFHOST_DEPLOYMENT = DEPLOYMENT === 'selfhost'
export const IS_CLOUD_DEPLOYMENT = DEPLOYMENT === 'cloud'
